/** @jsxImportSource theme-ui */

import React from 'react';
import { Icon } from '../Icon';
import { getVariant } from '../utils';
import { FontSizeProps } from '../utils/types';
import { ResponsiveStyleValue } from 'theme-ui';
import { colors } from '../../tokens';
import { spacing } from '../../tokens/sizing';
import FlexContainer from '../FlexContainer';

export interface LinkProps extends FontSizeProps, Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'color' | 'css'> {
    to?: string;
    disabled?: boolean;
    color?: ResponsiveStyleValue<keyof typeof colors.base>;
    variant?: 'default' | 'no-underline';
}

function TextLink({ children, color, size, variant, disabled, ...otherProps }: LinkProps): JSX.Element {
    const decoratedVariant = disabled ? `${variant}-disabled` : variant;
    return (
        <span>
            <a
                href={disabled ? null : otherProps.to}
                sx={{
                    variant: getVariant({ stylePath: 'links.text', variant: decoratedVariant }),
                    color: color,
                    fontSize: size,
                }}
                {...otherProps}
            >
                {children}
            </a>
        </span>
    );
}

function ArrowLink({ children, color, size, disabled, ...otherProps }: LinkProps): JSX.Element {
    const decoratedVariant = disabled ? 'default-disabled' : 'default';
    return (
        <FlexContainer direction="row" stack="none" alignItems="baseline" wrap="nowrap" gap={spacing.tiny}>
            <span>
                <Icon color="carrotOrange" size="tiny" name="rightArrow" />
            </span>
            <a
                href={disabled ? null : otherProps.to}
                sx={{
                    variant: getVariant({ stylePath: 'links.arrow', variant: decoratedVariant }),
                    color: color,
                    fontSize: size,
                }}
                {...otherProps}
            >
                {children}
            </a>
        </FlexContainer>
    );
}

ArrowLink.defaultProps = {
    color: colors.base.black80,
    size: 'small',
};

TextLink.defaultProps = {
    color: colors.base.black80,
    size: 'small',
    variant: 'default',
};

export { TextLink, ArrowLink };
